<template>
  <div style="overflow: auto;">
    <table class="table" style="padding-top: 5px">
      <tbody>
        <tr v-for="c in clientes" @click="cliente(c.id)" :class="!c.lido ? 'txtBold clienteMsg' : 'clienteMsg'">
            <td style="text-align: center;"><img :src="c.img" class="img-msg" @error="syncClient(c.id)"/></td>
            <td>{{c.nome.toUpperCase()}} <i v-show="!c.lido" class="fa fa-exclamation" aria-hidden="true" style="color: green"></i>
            <p style="font-size: .6em;">Ultima mensagem: {{c.mensagem[c.mensagem.length - 1].date | ajusteDate}}</p> </td> 
        </tr>
      </tbody>
  </table>
  </div>
</template>
<script>
export default {
  props: {
    'clientes': {
      type: Array,
      default: () => []
    }
  },
  methods: {
    cliente(id) {
      this.$emit('selectedCliente', id)
    },
    syncClient(id) {
        console.log('atualizando imagem ', id)
        this.$emit('atualizarImagem', id);
    }
  },
  filters: {
    ajusteDate (value) {
      let data = new Date(value);
      let newDate = (new Date(data.getTime() - data.getTimezoneOffset() * 60000)).toISOString();
      let aux = newDate.split('T');
      let date = aux[0].split('-');
      let hr = aux[1];
      return date[2] + '/' + date[1] + '/' + date[0] + ' - ' + hr.substring(0,5);
    }
  }
}
</script>
<style>
  .img-msg {
    border-radius: 50%;
    width: 50px
  }
  .clienteMsg:hover {
    cursor: pointer;
  }
  .txtBold {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// ListUsers.vue?c1e83076